import React, { useState } from "react";
import { enGB } from "date-fns/locale";
// import { DatePicker } from "react-nice-dates";
// import "react-nice-dates/build/style.css";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { parseISO } from "date-fns";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import { TextField } from "@mui/material";
export const BasicDatePicker = (props: {
  date: any;
  setDate: any;
  maxDate?: any;
  minDate?: any;
}) => {
  const handleDateChange = (newDate: any) => {
    // Parse the date if it comes as a string
    const parsedDate =
      typeof newDate === "string" ? parseISO(newDate) : newDate;
    props.setDate(parsedDate);
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DesktopDatePicker
        maxDate={props.maxDate}
        minDate={props.minDate}
        // label="Select Date"
        inputFormat="MM/DD/YYYY"
        value={props.date}
        onChange={handleDateChange}
        renderInput={(params) => <TextField {...params} />}
      />
      {/* <DatePicker
        maximumDate={props.maxDate}
        minimumDate={props.minDate}
        date={props.date}
        onDateChange={handleDateChange}
        locale={enGB}
      >
        {({ inputProps, focused }) => (
          <Input
            style={{ width: 120 }}
            className={"input" + (focused ? " -focused" : "")}
            {...inputProps}
          />
        )}
      </DatePicker> */}
    </LocalizationProvider>
  );
};
